export default "/images/198c0e6f97b88d122dd64cc1d8f9ece0.avif";